import React from 'react'
import { MDBBtn, MDBCard, MDBCardBody, MDBCol,  MDBRow, MDBFooter } from 'mdbreact';
import {  Redirect } from 'react-router-dom';

import greenTickMark from '../../Assets/green_tickmark.svg';
import axios from '../../authAxios';

// const brand_color = localStorage.getItem('brand_color')

export class PaymentSuccess extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            brand_color : "",
            isContineClicked:false,
        }
    }
    componentDidMount() {
        //localStorage.setItem('application_id','ABCD123456')
        this.setState({brand_color : localStorage.getItem("brand_color")})
        this.updatePaymentStatus(localStorage.getItem('user_id'),localStorage.getItem('application_id'));
    }

    updatePaymentStatus(userId,applicationId) {
        axios.post("/visa-payment/updatePaymentProcessingStatus",{
            "user_id": userId,
            "applicationId": applicationId,
            "payment_gateway":"",
            "txStatus": "SUCCESS",
            "transactionObj": {
                "paymentMode": "",
                "orderId": "",
                "txTime": "",
                "referenceId": "",
                "type": "",
                "txMsg": "msg",
                "signature": "",
                "orderAmount": ""
            }
        },{
            'Content-Type' : 'application/json'
        })
        .then((resp) => {
            // console.log(resp.data.dataobj);
        }).catch((err)=>{
            console.log(err);
        })
    }

    handleContinueBtnClick = e => {
    this.setState({isContineClicked:true})
    }
    render() {
        if (this.state.isContineClicked) {
            return <Redirect to="/track-application" />
        }
        return (
            <div>
                <h4><b>Payment Gateway</b></h4>
                <div className="mt-4" style={{ padding: '3%', width:'100%',height:'100%',textAlign:'center'}}>
                    <MDBCard style={{ width:'100%',height:'100%'}}>
                        <MDBCardBody>
                            <MDBCol >
                            <img style={{marginTop:'3%',width:'80px',height:'80px'}}src={greenTickMark} /> 
                                <div style={{padding:'3%'}}>
                                
                                 Your payment has been processed successfully and Visa application has been submitted.
                                 <br/>
                                 <br/>
                                 Appointment Tracking no. <b>{localStorage.getItem('application_reference_code')}</b>
                                 </div>
                            </MDBCol>
                             

                        </MDBCardBody>
                    </MDBCard>
                </div>
                <MDBRow>
                <MDBFooter style={{background: "#fff" ,  position: "fixed", bottom: "0px" ,width: "100%" , zIndex : "1" ,   left: "0" , right: "0" , borderTop: "1px solid #ccc" , boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)"}} color="white" className="pb-1 pt-1 text-right">
                        <MDBRow>
                            <MDBCol size="12" sm="6" md="6" lg="8" />
                            <MDBCol size="12" sm="6" md="6" lg="4">
                                <MDBBtn id="continueBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, width: '40%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleContinueBtnClick}>Continue</MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBFooter>
                </MDBRow>
            </div>
        )
    }
}

export default PaymentSuccess;
